// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ma-2";
export var chatLink = "_ma-0";
export var chatText = "_ma-1";